// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3QVQs","label":"LabeledBox_label__3PPv1"};